<template lang="pug">
	div.default-modal
		loading(:active.sync="busy", :is-full-page="false")
		.modal-header
			.modal-title Edit Offer <span v-if="offer">({{ offer.id }})</span>
			a.close(href="javascript:void(0);", @click="$emit('close')")
				i.la.la-times
		.modal-body
			.modal-body-inner
				form(@submit.prevent="submit", v-if="offer")
					.row
						.col-sm-6
							.form-group
								label Click Cap
								scheduled-input(v-model="offer.daily_click_cap", :scheduledChange="scheduledChanges.daily_click_cap", fieldName="daily_click_cap", :entityId="offer.id", entityType="offer", :disabled="shouldLockOfferClickImpressionCaps(offer)")
						.col-sm-6
							.form-group
								label Impression Cap &nbsp;
								i.la.la-info-circle(v-if="offer.daily_click_cap > 0 && !offer.daily_impression_cap && !isImprRateCapDerived(offer.impression_rate, USER.config.impressionCapAutoCalculation)", v-b-tooltip.hover.right, title="There is no cap on impressions, but once the click cap is reached offer will be paused")
								scheduled-input(v-model="offer.daily_impression_cap", :scheduledChange="scheduledChanges.daily_impression_cap", fieldName="daily_impression_cap", :entityId="offer.id", entityType="offer" :disabled="shouldLockOfferClickImpressionCaps(offer) || isImprRateCapDerived(offer.impression_rate, USER.config.impressionCapAutoCalculation)")
					.row(v-if="$store.state.user.config && $store.state.user.config.impressionRate")
						.col-sm-12
							.form-group
								impratio(
								v-model="offer.impression_rate",
								:click-cap="offer.daily_click_cap",
								:impression-cap="offer.daily_impression_cap",
								@update-impression-cap="offer.daily_impression_cap = $event"
								)
					.row
						.col-sm-6
							.form-group
								label Daily Conversion Cap
								scheduled-input(v-model="offer.daily_conversion_cap", :scheduledChange="scheduledChanges.daily_conversion_cap", fieldName="daily_conversion_cap", :entityId="offer.id", entityType="offer", :disabled="shouldLockOfferConversionCaps(offer)")
						.col-sm-6
							.form-group
								label Weekly Conversion Cap
									i.la.la-info-circle.ml-1(v-b-tooltip.hover.right, title="Monday to Sunday")
								scheduled-input(v-model="offer.weekly_conversion_cap", :scheduledChange="scheduledChanges.weekly_conversion_cap", fieldName="weekly_conversion_cap", :entityId="offer.id", entityType="offer", :disabled="shouldLockOfferConversionCaps(offer)")
					.row
						.col-sm-6
							.form-group
								label 
									| Daily Install Cap
									i.la.la-info-circle.ml-1(v-if="offer.payout_type === 'CPI'", v-b-tooltip.hover.bottom, title="Please use Conversion Cap on CPI offers")
								scheduled-input(v-model="offer.daily_install_cap", :scheduledChange="scheduledChanges.daily_install_cap", fieldName="daily_install_cap", :entityId="offer.id", entityType="offer" :readonly="offer.payout_type === 'CPI'", :disabled="shouldLockOfferConversionCaps(offer)")
					//- .row
					//- 	.col-sm-4
					//- 		.form-group
					//- 			b-form-checkbox(v-model="offer.lock_caps") Lock caps
					//- 	.col-sm-4
					//- 		.form-group
					//- 			b-form-checkbox(v-model="offer.lock_conversion_caps") Lock conversion caps

					.buttons.text-right
						button.btn.btn-primary(type="submit") Save
							i.la.la-fw.la-save
</template>
<script>
import Vue from 'vue';
import { shouldLockOfferClickImpressionCaps, shouldLockOfferConversionCaps } from '../../utils/offerCapsLock';
import { isImprRateCapDerived } from '../../utils/impression-rate-ctr-goal';

export default {
  name: 'QuickEditOfferModal',
  props: ['id'],
  methods: {
    shouldLockOfferClickImpressionCaps,
    shouldLockOfferConversionCaps,
    isImprRateCapDerived,
    async submit() {
      if (this.busy) {
        return;
      }
      let data = Vue.util.extend({}, this.offer);
      Vue.ovData.offer._booleans.forEach((f) => {
        data[f] = data[f] ? 1 : 0;
      });
      try {
        await this.$ovReq.post('offer/quickSave', data);
        this.$ovNotify.success('Offer has been saved');
        this.$emit('close');
      } catch (e) {
        console.error(e);
      }
      this.busy = false;
    },
  },
  data() {
    return {
      busy: false,
      offer: null,
      scheduledChanges: {},
    };
  },
  computed: {
    USER() {
      return this.$store.state.user;
    },
  },
  async created() {
    this.busy = true;
    try {
      const res = await this.$ovData.offer.get(this.id, true);
      this.offer = res.entity;
      this.scheduledChanges = res.scheduledChanges;
    } catch (e) {
      console.error(e);
      this.$emit('close');
    }
    this.busy = false;
  },
};
</script>
